/**
 * first_name, last_name을 [성+이름] 형식으로 통일
 * - 카카오/이메일 공유, 화면 표시 등에서 일관된 모금자명 사용
 * - 리뉴얼 후: first_name에만 전체 이름이 있는 경우(first_name만 사용)
 * - 기존: last_name(성) + first_name(이름) 조합
 */
export const formatUserFullName = (
  first_name?: string | null,
  last_name?: string | null,
): string => {
  const first = (first_name ?? '').trim();
  const last = (last_name ?? '').trim();

  if (last && first && last !== first) {
    return `${last}${first}`;
  }
  return (last || first) || '';
};
